module.exports = __webpack_public_path__ + "img/画中画开启演示.28e56786.gif";